import React from 'react'
import {Route, Switch, Redirect, NavLink} from 'react-router-dom'
import Layout from 'components/shared/Layout'
import Heading from 'components/shared/Heading'
import LogoutButton from 'components/shared/LogoutButton'
import ResponsiveNavLayout from 'components/shared/ResponsiveNavLayout'
import {Desktop} from 'components/shared/Responsive'
import PhotoOrderPreference from './PhotoOrderPreference'
import ExecutiveOfficers from './ExecutiveOfficers'
import GeneralPhotographerInstructions from './GeneralPhotographerInstructions'

import './index.scss'

const Settings = ({match, location}) => {
  const menuItems = [
    {
      key: 'photo-order',
      name: 'Romrekkefølge',
      path: '/romrekkefolge',
      component: PhotoOrderPreference,
    },
    {
      key: 'executive-officers',
      name: 'Saksbehandlere',
      path: '/saksbehandlere',
      component: ExecutiveOfficers,
    },
    {
      key: 'message',
      name: 'Fast beskjed til fotograf',
      path: '/beskjed-til-fotograf',
      component: GeneralPhotographerInstructions,
    },
  ]

  const backTo = match.isExact ? null : '/innstillinger'

  return (
    <Layout documentTitle="Innstillinger" backToPath={backTo}>
      <ResponsiveNavLayout
        isRoot={match.isExact}
        header={<Heading level={2}>Innstillinger</Heading>}
        sidebar={
          <>
            <nav>
              {menuItems.map(item => (
                <NavLink key={item.key} to={`${match.url}${item.path}`}>
                  {item.name}
                </NavLink>
              ))}
            </nav>
            <LogoutButton block />
          </>
        }
        content={
          <Switch>
            {menuItems.map((item) => (
              <Route
                key={item.key}
                path={`${match.path}${item.path}`}
                component={item.component}
              />
            ))}
            <Desktop>
              <Redirect to={`${match.path}/romrekkefolge`} />
            </Desktop>
          </Switch>
        }
      />
    </Layout>
  )
}

export default Settings
